export const historyCapacity = 100;

export class History<T> {
  private readonly capacity: number;
  private states: T[] = [];
  private index = -1;

  constructor(initial: T, capacity = historyCapacity) {
    this.capacity = Math.max(1, capacity);
    this.reset(initial);
  }

  current(): T {
    return this.states[this.index];
  }

  push(state: T): void {
    this.states = this.states.slice(0, this.index + 1);
    this.states.push(state);

    if (this.states.length > this.capacity) this.states = this.states.slice(this.states.length - this.capacity);

    this.index = this.states.length - 1;
  }

  undo(): T | null {
    if (!this.canUndo()) return null;

    this.index--;

    return this.states[this.index];
  }

  redo(): T | null {
    if (!this.canRedo()) return null;

    this.index++;

    return this.states[this.index];
  }

  canUndo(): boolean {
    return this.index > 0;
  }

  canRedo(): boolean {
    return this.index < this.states.length - 1;
  }

  reset(initial: T): void {
    this.states = [initial];
    this.index = 0;
  }

  size(): number {
    return this.states.length;
  }
}
